module.exports = __webpack_public_path__ + "media/img/tag-icon-97c05089.svg";